/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { ApiInformation } from "./data-contracts";

/**
 * @description Access the release version and build date of the GitBook codebase.
 * @tags system
 * @name GetApiInformation
 * @summary Get API information
 * @request GET:/
 * @secure
 */

// @ts-ignore
export const getApiInformation: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ApiInformation;
  ResponseStatusCode: 200;
} = {
  route: "/",
  method: "get",
  streaming: false,
  tags: ["system"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
